import AlertError from "@components/AlertError";
import ResourceService from "@core-ui/ContextServices/ResourceService/ResourceService";
import styled from "@emotion/styled";
import t from "@ext/localization/locale/translate";
import type { ReactNode } from "react";

const Wrapper = styled.div`
	margin: -4px -8px 0.2em -8px;
	padding: 4px 8px;
	*[data-focusable="true"] {
		outline: unset !important;
		outline-offset: unset !important;
	}
`;

interface FragmentProps {
	id: string;
	children: ReactNode;
}

const Fragment = ({ id, children }: FragmentProps) => {
	return children ? (
		<ResourceService.Provider id={id} provider="fragment">
			<Wrapper data-component="fragment" data-focusable="true" data-iseditable={false}>
				{children}
			</Wrapper>
		</ResourceService.Provider>
	) : (
		<AlertError error={{ message: t("cant-get-fragment-data") }} title={t("fragment-render-error")} />
	);
};

export default Fragment;
